import { getTranslateByKey } from "@/main/services/utils";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";
import * as S from "./styles";

interface IModalConfirmProps {
	setOpenModalConfirm: (openModalConfirm: boolean) => void;
	handleConfirm: () => void;
}

export function ModalConfirm({ setOpenModalConfirm, handleConfirm }: IModalConfirmProps) {
	return (
		<S.BoxModal>
			<S.TitleModal>{getTranslateByKey("information.confirmCreateQuoteWithTheSameClaimNumber")}</S.TitleModal>
			<S.ContainerButtons>
				<SecondaryButton
					id="id-confirmOrder-button-no"
					type="button"
					variant="outlined"
					color="primary"
					onClick={() => setOpenModalConfirm(false)}
				>
					{getTranslateByKey("information.no")}
				</SecondaryButton>
				<Button
					id="id-confirmOrder-button-yes"
					type="button"
					variant="contained"
					color="primary"
					onClick={() => handleConfirm()}
				>
					{getTranslateByKey("information.yes")}
				</Button>
			</S.ContainerButtons>
		</S.BoxModal>
	);
}
